export default __webpack_public_path__ + "static/media/drying-facilities-icon.29a56226.svg";